<template>
  <div class="container-fluid">
    <div class="block-header position-sticky">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">
              Linked Remitters
            </h5>
          </div>
          <div class="body">
            <b-table
              table-class="table-custom border"
              head-variant="light"
              :items="
                typeof linkedSenders === 'array' ||
                typeof linkedSenders === 'object'
                  ? linkedSenders
                  : []
              "
              :fields="linkedSendersfields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              responsive
              striped
              hover
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(country)="data">
                <div class="align-items-center d-flex">
                  <span
                    class="ml-0"
                    v-if="data.value.isocode"
                    :class="`flag-icon flag-icon-${data.value.isocode} fi-lg fi-round`"
                  ></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.country?.name"
                  >
                    {{ data.item.country?.isocode?.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(name)="data">
                <a
                  href="javascript:void(0);"
                  @click="editCustomer(data, 'sender')"
                >
                  {{
                    data.item.name
                      ? data.item.name +
                        " " +
                        data.item.mname +
                        " " +
                        data.item.lname
                      : "-"
                  }}
                </a>
              </template>
              <template #cell(receiver_name)="data">
                <a
                  href="javascript:void(0);"
                  @click="editCustomer(data, 'receiver')"
                >
                  {{
                    data.item.receiver_fname
                      ? data.item.receiver_fname +
                        " " +
                        data.item.receiver_lname
                      : "-"
                  }}
                </a>
              </template>
              <template #cell(payangel_id)="data">
                <span>
                  {{ data.value }}
                  <i
                    class="fa fa-copy"
                    v-if="data.value != '-'"
                    @click="copyText(data.value, 'Payangel Id')"
                  ></i>
                </span>
              </template>
              <template #cell(phonenumber)="data">
                <span>
                  {{ data.value }}
                  <i
                    class="fa fa-copy"
                    v-if="data.value != '-'"
                    @click="copyText(data.value, 'Phone Number')"
                  ></i>
                </span>
              </template>
              <template #cell(status)="data">
                <p class="function-badge badge-group-table mb-0">
                  <span class="badge ml-0" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                >
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['receiver.edit'])">
                    <b-dropdown-item @click="showRelation(data)">
                      Edit
                    </b-dropdown-item>
                  </template>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="d-flex py-3 align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="card">
                    <div class="header border-bottom">
                        <h5 class="text-primary font-weight-normal mb-0">Block Box</h5>
                    </div>
                    <div class="body">
                    
                    </div>
                </div> -->
        <div class="d-md-flex align-items-start">
          <div class="card">
            <div
              class="header border-bottom accordian-toggle"
              v-b-toggle.bankAccounts
              @click="getBankAccounts"
            >
              <h5 class="text-primary font-weight-normal mb-0">
                Bank Accounts
              </h5>
            </div>
            <b-collapse id="bankAccounts">
              <div class="body">
                <b-table
                  responsive
                  outlined
                  table-class="mb-0 table-custom"
                  head-variant="light"
                  :items="banksaccounts"
                  :fields="bankfields"
                  :emptyText="'No data found.'"
                  show-empty
                  striped
                >
                  <template #cell(account_number)="data">
                    <a
                      href="javascript:void(0);"
                      @click="viewAccounts(data.item)"
                    >
                      {{ data.value }}
                    </a>
                  </template>
                  <template #cell(block_status)="data">
                    {{ data.value }}
                    <select
                      class="btn btn-filter badge badge-primary btn-sm"
                      v-model="data.value"
                    >
                      <option value="">Select Option</option>
                      <option
                        v-for="(option, index) in blockStatuses"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                  </template>
                </b-table>
              </div>
            </b-collapse>
          </div>
          <div class="card ml-2">
            <div
              class="header border-bottom accordian-toggle"
              v-b-toggle.momoAccounts
              @click="getmomoAccounts"
            >
              <h5 class="text-primary font-weight-normal mb-0">
                MOMO Accounts
              </h5>
            </div>
            <b-collapse id="momoAccounts">
              <div class="body">
                <b-table
                  responsive
                  outlined
                  table-class="mb-0 table-custom"
                  head-variant="light"
                  :items="momoaccounts"
                  :fields="momoaccountfields"
                  :emptyText="'No data found.'"
                  show-empty
                  striped
                >
                  <template #cell(momo_number)="data">
                    <a
                      href="javascript:void(0);"
                      @click="viewAccounts(data.item)"
                    >
                      {{ data.value }}
                    </a>
                  </template>
                  <template #cell(block_status)="data">
                    {{ data.value }}
                    <select
                      class="btn btn-filter badge badge-primary btn-sm"
                      v-model="data.value"
                    >
                      <option value="">Select Option</option>
                      <option
                        v-for="(option, index) in blockStatuses"
                        :key="index"
                        :value="option"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                  </template>
                </b-table>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GET_LINKED_REMITTERS,
  GET_BANKACCOUNTS,
  GET_MOMOACCOUNTS,
} from "../../../store/actions.type.js";
import { mapGetters } from "vuex";
export default {
  name: "LinkedRemitterPage",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
  props: {
    beneficiaryDetail: Object,
  },
  data() {
    return {
      linkedSenders: [],
      linkedSendersfields: [
        { key: "country", tdClass: "p-2" },
        { key: "name", sortable: true, tdClass: "p-2" },
        { key: "receiver_name", label: "Receiver Name", tdClass: "p-2" },
        { key: "payangel_id", tdClass: "p-2" },
        { key: "phonenumber", tdClass: "p-2" },
        { key: "status", tdClass: "p-2" },
        { key: "action", tdClass: "p-2" },
      ],
      blockStatuses: [
        { value: "Monitor" },
        { value: "Restricted" },
        { value: "Suspended" },
        { value: "Terminated" },
        { value: "Blacklisted" },
        { value: "Approved" },
      ],
      breadCrumbIteams: [
        {
          title: "Receivers",
          links: "",
        },
        {
          title: "Receivers Details", //Linked remitters
          links: "",
        },
      ],
      banksaccounts: [],
      momoaccounts: [],
      bankAccountsloaded: false,
      momoAccountsloaded: false,
      bankfields: [
        { key: "name", label: "Name", thClass: "th_sortfix" },
        {
          key: "account_number",
          label: "Account Number",
          thClass: "th_sortfix",
        },
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],
      momoaccountfields: [
        { key: "network", label: "Network", thClass: "th_sortfix" },
        { key: "momo_number", label: "Mobile Number", thClass: "th_sortfix" },
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: true,
    };
  },
  methods: {
    editCustomer(data, user) {
      let id =
        user == "sender"
          ? data.item.id
          : this.$CryptoJS.AES.decrypt(
              this.$route.params?.beneficiary_id,
              "beneficiary_id",
            ).toString(this.$CryptoJS.enc.Utf8);
      this.$router.push({
        name: "customer-edit",
        params: {
          customer_id: this.$CryptoJS.AES.encrypt(id, "customer_id").toString(),
        },
      });
    },
    // view edit Accounts page
    viewAccounts(data) {
      let params = {};
      if (data.account_number) {
        params.name = "Bank Account";
        params.value = data.account_number;
      }
      if (data.momo_number) {
        params.name = "MOMO Account";
        params.value = data.momo_number;
      }
      this.$router.push({
        path: "/accounts/edit",
        query: {
          name: this.$CryptoJS.AES.encrypt(params.name, "name").toString(),
          value: this.$CryptoJS.AES.encrypt(params.value, "value").toString(),
        },
      });
    },
    // Get remitter bank accounts details
    getBankAccounts() {
      if (this.bankAccountsloaded) {
        return;
      }
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.beneficiary_id,
        "beneficiary_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      const tempitems = [];
      let tempparam = `?beneficiaryId=${id}`;
      this.$store.dispatch(GET_BANKACCOUNTS, tempparam).then((response) => {
        if (response.status == 200) {
          let details = response.data.details;
          details.map((item) => {
            let accounts = {
              name: item.bank_name ? item.bank_name : "-",
              branchname: item.branchname ? item.branchname : "-",
              account_number: item.account_number ? item.account_number : "-",
            };
            tempitems.push(accounts);
          });
        } else {
          this.$toast.error(response.data.message, { position: "top-right" });
        }
        this.bankAccountsloaded = true;
        this.banksaccounts = tempitems;
      });
    },
    // Get remitter momo accounts details
    getmomoAccounts() {
      if (this.momoAccountsloaded) {
        return;
      }
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.beneficiary_id,
        "beneficiary_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      const tempitems = [];
      let tempparam = `?beneficiaryId=${id}`;
      this.$store.dispatch(GET_MOMOACCOUNTS, tempparam).then((response) => {
        if (response.status == 200) {
          let details = response.data.details;
          details.map((item) => {
            let accounts = {
              network: item.provider_name,
              momo_number: item.wallet_number,
            };
            tempitems.push(accounts);
          });
        } else {
          this.$toast.error(response.data.message, { position: "top-right" });
        }
        this.momoAccountsloaded = true;
        this.momoaccounts = tempitems;
      });
    },
    empty() {
      this.totalRows = 1;
      this.currentPage = 1;
      this.currentPageJump = 1;
      this.perPage = 10;
      this.sortBy = "";
      this.sortDesc = true;
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.items = [];
      if (this.sortBy != "") {
        this.linkedRemitter();
      }
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      this.$toast.success(`${type} Copied`, { position: "top-right" });
    },
    blacklistIp() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to blacklist Ip for this Customer?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, blacklist it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Blacklisted!",
              "IP address has been blacklisted for this Customer.",
              "success",
            );
          }
        });
    },
    showRelation(data) {
      let params = {
        beneficiary_id: this.$route.params?.beneficiary_id,
        customer_id: this.$CryptoJS.AES.encrypt(
          data.item.id,
          "customer_id",
        ).toString(),
        country_id: this.$route.params?.country_id,
      };
      this.$router.push({ name: "beneficiary-edit", params: params });
    },
    async linkedRemitter() {
      const tempitems = [];
      this.linkedSenders = [];
      let page = "";
      let page_size = "";
      let sortby = "";
      let sort = false;
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        page_size = this.perPage;
      } else {
        page_size = 50;
      }
      if (this.sortBy == "") {
        sortby = "createdAt";
      } else if (this.sortBy == "name") {
        sortby = "firstname";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "DESC";
      } else {
        sort = "ASC";
      }
      this.currentPageJump = page;
      let tempparam = {};
      tempparam.query = `?sorting=${sort}&sortby=${sortby}&pagesize=${page_size}&page=${page}`;
      tempparam.beneficiaryid = this.$CryptoJS.AES.decrypt(
        this.$route.params?.beneficiary_id,
        "beneficiary_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      await this.$store
        .dispatch(GET_LINKED_REMITTERS, tempparam)
        .then((response) => {
          if (response.status == 200) {
            response.data.details.map((item) => {
              let statusobj = "";
              if (item.status === 1) {
                statusobj = { name: "Active", class: "badge-success" };
              } else if (item.status === 0) {
                statusobj = { name: "InActive", class: "badge-danger" };
              } else {
                statusobj = { name: "N/A", class: "badge-grey" };
              }
              let customerLists = {
                id: item.id,
                name: item.firstname != null ? item.firstname : "",
                mname: item.middlename != null ? item.middlename : "",
                lname: item.lastname != null ? item.lastname : "",
                receiver_fname:
                  item.beneffirstname != null ? item.beneffirstname : "",
                receiver_lname:
                  item.beneflastname != null ? item.beneflastname : "",
                payangel_id: item.payangelId ? item.payangelId : "-",
                phonenumber: item.phone ? item.phone : "-",
                country: item.countryofresidence
                  ? this.countryList.filter(
                      (data) => data.countryid === item.countryofresidence,
                    )[0]
                  : "-",
                status: statusobj,
              };
              tempitems.push(customerLists);
            });
            this.totalRows = response.data.query.total;
          }
        });
      this.linkedSenders = tempitems;
    },
  },
  async mounted() {
    await this.linkedRemitter();
  },
  watch: {
    currentPage: {
      handler: function () {
        this.linkedRemitter();
      },
    },
    perPage: {
      handler: function () {
        this.linkedRemitter();
      },
    },
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
  },
};
</script>
